import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container, Link } from './ui';

const StyledCtaCards = styled.section`
  ${sectionMargins()};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.medium`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

const StyledItem = styled.article`
  &:nth-child(odd) {
    background-color: ${brandColours.denary};
  }

  &:nth-child(even) {
    background-color: ${brandColours.septenary};
  }
`;

const StyledInner = styled(Link)`
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  height: 100%;
`;

const StyledGroup = styled.div`
  padding: 20px;

  ${minBreakpointQuery.tiny`
    padding: 25px;
  `}

  ${minBreakpointQuery.small`
    padding: 30px;
  `}

  ${minBreakpointQuery.large`
    padding: 40px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding: 50px;
  `}
`;

const StyledHeading = styled.h3`
  font-weight: ${fontWeights.semibold};
  ${fontSize(20)};

  ${minBreakpointQuery.tiny`
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.small`
    ${fontSize(24)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(26)};
  `}
`;

const StyledText = styled.p`
  margin-top: 8px;
  ${fontSize(14)};
  line-height: 1.5;

  ${minBreakpointQuery.tiny`
    ${fontSize(16)};
  `}

  ${minBreakpointQuery.large`
    margin-top: 12px;
    ${fontSize(18)};
  `}
`;

const StyledIcon = styled.img`
  display: block;
  margin: auto;
  width: 100%;
  max-width: 140px;
`;

const StyledImage = styled(GatsbyImage)`
  margin-left: auto;
  height: 100%;
  max-width: 160px;

  ${minBreakpointQuery.large`
    max-width: 180px;
  `}

  ${minBreakpointQuery.xxlarge`
    max-width: 200px;
  `}
`;

const CtaCards = ({ items }) => (
  <StyledCtaCards>
    <Container>
      <StyledItems>
        {items.map(({ heading, text, iconOrImage, link }, id) => (
          <StyledItem key={id}>
            <StyledInner to={link.pageUrl}>
              <StyledGroup>
                <StyledHeading>{heading}</StyledHeading>
                <StyledText>{text}</StyledText>
              </StyledGroup>
              {iconOrImage.icon ? (
                <StyledGroup>
                  <StyledIcon
                    src={iconOrImage.icon.url}
                    alt={iconOrImage.icon.alt}
                    loading="lazy"
                  />
                </StyledGroup>
              ) : (
                <StyledImage
                  image={iconOrImage.image.gatsbyImageData}
                  alt={iconOrImage.image.alt}
                  objectPosition="0 50%"
                />
              )}
            </StyledInner>
          </StyledItem>
        ))}
      </StyledItems>
    </Container>
  </StyledCtaCards>
);

export default CtaCards;
